import type { Template, TemplateEngine } from '@/app/dashboard/templates/components/types/template';

export function resolveTemplateEngine(
  template?: (Pick<Template, 'engine' | 'pagedFlip' | 'pagedNodes'> & { pages?: unknown }) | null,
): TemplateEngine {
  // Checked before the paged heuristics below: a storefront template may still
  // carry legacy `pages` data from before it was switched over, and the
  // explicit engine must win over an inference from leftover fields.
  if (template?.engine === 'storefront') return 'storefront';
  if (template?.engine === 'paged-flip') return 'paged-flip';
  if (template?.pagedFlip || template?.pagedNodes) return 'paged-flip';
  if (Array.isArray(template?.pages)) return 'paged-flip';
  return 'legacy-scroll';
}

/**
 * True when the menu body is rendered by Menuraq rather than by the template's
 * own layout engine — either because the merchant chose `storefront`, or
 * because a paged template was demoted on the customer surface.
 */
export function usesStorefrontBody(
  template?: (Pick<Template, 'engine' | 'pagedFlip' | 'pagedNodes'> & { pages?: unknown }) | null,
): boolean {
  const engine = resolveTemplateEngine(template);
  return engine === 'storefront' || engine === 'paged-flip';
}

export function isPagedFlipTemplate(
  template?: (Pick<Template, 'engine' | 'pagedFlip' | 'pagedNodes'> & { pages?: unknown }) | null,
): boolean {
  return resolveTemplateEngine(template) === 'paged-flip';
}
